module.exports = __webpack_public_path__ + "media/images/partners/2-af90b28fc7b3d94dd1e84ed4c320dc6f.png";